"use strict";
/*
 * Created on 21. 2. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var ResultSeverity_1 = require("../../../core/model/errors/ResultSeverity");

var ValidationResultFlag_1 = require("../../../core/model/errors/ValidationResultFlag");

var ValidationResultObject_1 = require("../../../core/model/errors/ValidationResultObject");

var EntityEventFlag_1 = require("../../../core/model/event/EntityEventFlag");

var FlagSet_1 = require("../../../core/model/FlagSet");

var ReleasePartValidationKey_1 = require("../../../release/model/alerts/ReleasePartValidationKey");

var RequiresRecalculation_1 = require("../../../release/model/alerts/RequiresRecalculation");
/**
 * Product tier changed event.
 * @author Radek Beran
 */


var ProductTierChanged =
/*#__PURE__*/
function (_EntityEventFlag_1$En) {
  _inherits(ProductTierChanged, _EntityEventFlag_1$En);

  function ProductTierChanged() {
    _classCallCheck(this, ProductTierChanged);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductTierChanged).apply(this, arguments));
  }

  _createClass(ProductTierChanged, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return ProductTierChanged;
}(EntityEventFlag_1.EntityEventFlag);

exports.ProductTierChanged = ProductTierChanged;
ProductTierChanged.TAG = EntityEventFlag_1.EntityEventFlag.register(ProductTierChanged);
ProductTierChanged.INSTANCE = new ProductTierChanged();
ProductTierChanged.MESSAGE = new ValidationResultObject_1.ValidationResultObject(ResultSeverity_1.ResultSeverity.Warn, ReleasePartValidationKey_1.ReleasePartMessageCode.TierChanged, immutable_1.List.of(), 'baf', null, FlagSet_1.FlagSet.of(ValidationResultFlag_1.ValidationResultFlag, RequiresRecalculation_1.RequiresRecalculation.INSTANCE));